import { Component, OnInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { Banner } from '../banner.model';
import { NgForm } from '../../../../node_modules/@angular/forms';
import { Router, ActivatedRoute } from '../../../../node_modules/@angular/router';
import { NavigationService } from '../../shared-services/navigation.service';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { FormValidatorService } from '../../shared-services/form-validator.service';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { Response } from '@angular/http';
import { ImagenBanner } from '../banner-imagen-upload/imagen-banner.model';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material';
import { MomentDateAdapter, MOMENT_DATE_FORMATS } from '../../shared-services/date-adapter';
import * as moment from 'moment';
import { Cliente } from "../../cliente/cliente.model";
import { BannerResolver } from '../banner.resolver';
import { ImagenBannerDto } from '../imagen-bannerDto.model';

/*export class MyDateAdapter extends NativeDateAdapter {
  parse(value: any): Date | null {
    debugger;
    if ((typeof value === 'string') && (value.indexOf('/') > -1)) {
      const str = value.split('/');
      const year = Number(str[2]);
      const month = Number(str[1]) - 1;
      const date = Number(str[0]);
      return new Date(year, month, date);
    }
    const timestamp = typeof value === 'number' ? value : Date.parse(value);
    return isNaN(timestamp) ? null : new Date(timestamp);
  }
  format(date: Date, displayFormat: Object): string {
      if (displayFormat == "input") {
          let day = date.getDate();
          let month = date.getMonth() + 1;
          let year = date.getFullYear();
          return this._to2digit(day) + '/' + this._to2digit(month) + '/' + year;
      } else {
          return date.toDateString();
      }
  }

  private _to2digit(n: number) {
      return ('00' + n).slice(-2);
  }
}

export const APP_DATE_FORMATS =
{
   parse: {
       dateInput: {month: 'short', year: 'numeric', day: 'numeric'}
   },
   display: {
       // dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
       dateInput: 'input',
       // monthYearLabel: { month: 'short', year: 'numeric', day: 'numeric' },
       monthYearLabel: 'inputMonth',
       dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
       monthYearA11yLabel: {year: 'numeric', month: 'long'},
   }
}*/

@Component({
  selector: 'app-banner-add',
  templateUrl: './banner-add.component.html',
  styleUrls: ['./banner-add.component.scss'],
 providers: [
  { provide: MAT_DATE_LOCALE, useValue: 'es-Ar' },
  { provide: DateAdapter, useClass: MomentDateAdapter },
  { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS }
  ]
})
export class BannerAddComponent implements OnInit {

  banner: Banner;
  imagen: ImagenBanner;
  imagenAdd: ImagenBannerDto;
  validationFail = false;
  activo = true;
  clientes: Cliente[];
  @ViewChild('form') public bannerForm: NgForm;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private snackService: SnackService,
    private backendService: BackendService,
    private formValidatorService: FormValidatorService,
    private dialogService: DialogService,
    private bannerResolver: BannerResolver
  ) { }

  async ngOnInit() {
  }
  
  back() {
    this.navigationService.back();
  }

  setImagen(event) {
    this.imagen = event;
    console.log(event)
  }

  async confirmSave() {
    console.log(this.imagen)

    if (this.validateForm()) {
      console.log("aaa")
        this.dialogService.confirm(this.imagen.id ? 'Edición de banner' : 'Alta de banner',
        '¿Está seguro que desea guardar el banner ' + this.imagen.nombre + '?')
        .then( res => {
          console.log(res)
          if (res) {
            this.save(res);
          }
        });
    }
  }

  validateForm() {
    let validationsOK = false;
    console.log("AABB")
    // Valida el resto de los controles con sus validadores
    if (this.imagen == null) {
      validationsOK = false;
      this.validationFail = true;
    } else {
      validationsOK = true;
      this.validationFail = false;
    }
    
    return validationsOK;
  }

  validarImagenes() {
    if (!this.imagen) {
      this.snackService.error('Debe cargar al menos una imágen.');
      return false;
    }
    return true;
  }

  async save(res) {
    console.log("AAAA")
    if (res) {
      this.snackService.spinner(true);

      console.log("ASNFDJSANFAS")
      if (this.imagen.id == 184218124821321) { // Update
        try {
          await await this.backendService.update(Banner.path + this.banner.id, this.banner);
          this.saveImagenes(this.banner.id);
          await this.delay(600);
          this.snackService.success('Banner editado satisfactoriamente');
          this.router.navigate(['/banner']);
        } catch (ex) {
          if (ex[0]) {
            this.snackService.error(ex[0].details);
          } else if (ex.errors) {
            this.snackService.error(ex.errors[0].defaultMessage);
          } else {
            this.snackService.error(ex.message);
          }
        } finally {
          this.snackService.spinner(false);
        }
      } else {
        console.log("BBBB")
        try {
          console.log(this.imagen)
          this.imagenAdd.nombre = this.imagen.nombre;
          this.imagenAdd.path = this.imagen.path
          const response = await this.backendService.createWithResponse(Banner.path, this.imagenAdd);
          console.log("CCCC")
          const clienteResponse = JSON.parse((response as Response).text());
          console.log("DDDD")
          this.saveImagenes(clienteResponse.id);
          console.log("EEEE")
          this.snackService.success('Banner creado satisfactoriamente');
        } catch (ex) {
          if (ex[0]) {
            this.snackService.error(ex[0].details);
          } else if (ex.errors) {
            this.snackService.error(ex.errors[0].defaultMessage);
          } else {
            this.snackService.error(ex.message);
          }
        } finally {
          this.snackService.spinner(false);
        }
      }
    }
  }

  async saveImagenes(bannerId) {
    try {
      let formdata: FormData;
      const archivo = this.imagen;
      console.log(archivo)
      //if (archivo.id !== undefined && archivo.file !== null && archivo.file !== undefined) {
        formdata = new FormData();
        formdata.append('file', archivo.file);
        formdata.append('name', archivo.nombre);
        formdata.append('id', bannerId);
        console.log(formdata)
        await this.backendService.createFile(Banner.path + 'subirImagenCarousel', formdata);
      //}
    } catch (ex) {
      this.snackService.error(ex.message);
    }
  }

  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

}



// WEBPACK FOOTER //
// ./src/app/banner/banner-add/banner-add.component.ts